var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlays(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29,
    height: 25,
    viewBox: "0 0 29 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "c8kjvlqila",
    d: "M0 0L15.891 0 15.891 17.091 0 17.091z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E8DED1",
    d: "M27.869 10.386c-3.311-1.395-6.86-2.244-10.44-2.396.12 1.213.06 2.426-.178 3.61-.03.213-.12.395-.15.607.21-.06.448-.06.657-.03.775.152 1.372.789 1.61 1.76.03.15 0 .303-.12.394-.088.12-.237.152-.386.12l-2.476-.424c-.895 1.67-2.267 3.034-3.937 3.822.03.456.089.88.179 1.335.596 2.944 2.863 5.188 5.786 5.704 2.923.516 5.786-.789 7.367-3.337.686-1.122 1.134-2.335 1.372-3.64l1.163-6.706c.03-.332-.12-.666-.447-.819m-5.995 10.347l-5.34-.942c-.297-.06-.506-.364-.387-.666.537-1.457 2.029-2.398 3.609-2.095 1.58.273 2.685 1.67 2.685 3.246.03.274-.24.517-.567.457m2.923-5.402c-.09.122-.24.152-.388.122l-2.893-.515c-.15-.03-.268-.123-.328-.244-.06-.12-.06-.303.03-.424.507-.82 1.312-1.245 2.088-1.092.775.151 1.372.788 1.61 1.76 0 .12-.03.272-.12.393"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "gj811i4ezb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c8kjvlqila"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D99EBA",
    d: "M15.67 11.266c.268-1.274.298-2.609.06-3.883L14.566.648c-.059-.334-.328-.577-.656-.608C9.317-.202 4.664.648.43 2.468c-.299.121-.478.455-.419.788l1.164 6.736c.238 1.305.686 2.518 1.372 3.641 1.55 2.548 4.444 3.883 7.367 3.337 2.893-.516 5.16-2.76 5.756-5.704zM3.92 7.534c-.15.031-.3-.03-.389-.12-.09-.122-.149-.244-.119-.396.208-.94.805-1.607 1.58-1.759.776-.152 1.551.273 2.088 1.092.09.122.09.273.03.425-.06.152-.179.242-.328.273l-2.863.485zm5.278 5.522c-1.58.273-3.072-.637-3.609-2.093-.12-.303.09-.607.388-.667l5.338-.94c.3-.062.597.181.597.484-.03 1.548-1.133 2.913-2.714 3.216zm3.46-7.312c-.06.122-.179.243-.329.273l-2.893.516c-.149.031-.298-.03-.387-.12-.09-.123-.15-.244-.12-.396.21-.94.806-1.607 1.581-1.759.776-.152 1.551.273 2.088 1.092.09.122.09.273.06.394z",
    mask: "url(#gj811i4ezb)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlays);
export default __webpack_public_path__ + "static/media/Plays.b708123117ca03bac324ef9813852313.svg";
export { ForwardRef as ReactComponent };